// removed by extract-text-webpack-plugin
module.exports = {"modalContainer":"Filters__modalContainer___MYwwq","modalBody":"Filters__modalBody___1YdxO","title":"Filters__title___2dVqh","subtitle":"Filters__subtitle___1os9-","dividerDouble":"Filters__dividerDouble___3FyNd","CTAContainer":"Filters__CTAContainer___3VtVw","filtersContainer":"Filters__filtersContainer___1R_z6"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/projects/components/Filters.scss
// module id = 1732
// module chunks = 0